export const craftDiaryPage = {
  seo: {
    title: "職人日誌｜來加綉綉紅豆餅手作紀錄",
    description:
      "來加綉綉職人日誌分享紅豆餅製作、餅皮火候、內餡設計、回烤技巧、市集觀察與加盟經營知識，讓顧客看見品牌背後的手作精神。",
  },
  hero: {
    tag: "職人日誌",
    title: "職人日誌",
    subtitle:
      "記錄一顆紅豆餅從餅皮、內餡、火候到顧客手上的過程，也分享我們對產品與經營的觀察。",
  },
  categories: [
    { id: "all", label: "全部" },
    { id: "craft", label: "產品製作" },
    { id: "filling", label: "內餡與口味" },
    { id: "reheat", label: "冷凍回烤" },
    { id: "market", label: "市集觀察" },
    { id: "franchise", label: "加盟經營" },
    { id: "brand", label: "品牌故事" },
  ],
  articles: [
    {
      id: 1,
      category: "craft",
      categoryLabel: "產品製作",
      title: "一顆好吃的紅豆餅，關鍵不只在內餡",
      summary:
        "餅皮厚薄、火候時間與出餐節奏，都會影響顧客第一口的記憶。",
    },
    {
      id: 2,
      category: "craft",
      categoryLabel: "產品製作",
      title: "為什麼紅豆餅需要穩定的產品 SOP？",
      summary:
        "穩定不是失去手作感，而是讓每位顧客每次購買都能安心期待。",
    },
    {
      id: 3,
      category: "reheat",
      categoryLabel: "冷凍回烤",
      title: "冷凍紅豆餅怎麼回烤才好吃？",
      summary:
        "從保存、退冰到回烤時間，整理給顧客在家享用的建議。",
    },
    {
      id: 4,
      category: "market",
      categoryLabel: "市集觀察",
      title: "市集與店面的紅豆餅經營差在哪裡？",
      summary:
        "不同場域需要不同出餐節奏、產品組合與客群溝通。",
    },
    {
      id: 5,
      category: "franchise",
      categoryLabel: "加盟經營",
      title: "想做紅豆餅副業，先想清楚這 5 件事",
      summary:
        "時間、預算、地點、產品與銷售方式，會決定經營路線。",
    },
    {
      id: 6,
      category: "brand",
      categoryLabel: "品牌故事",
      title: "傳統點心也能做品牌嗎？",
      summary:
        "從口味、視覺、社群到顧客體驗，讓紅豆餅不只是小吃，也可以是品牌。",
    },
  ],
  bottomCta: {
    title: "想更了解產品或合作？",
    ctaPrimary: "查看產品介紹",
    ctaSecondary: "了解加盟專區",
  },
};